export default __webpack_public_path__ + "static/media/ProductRequirement_HeroBanner.2e28ab2c.png";